<section class="page-container">
    <div class="flex min-w-0 items-center justify-between gap-4">
      <h1 class="main-heading min-w-0">Weekly Focus Dashboard</h1>
      <app-navpath class="hidden md:block" />
    </div>
    <section class="content-container">
      <div class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row md:items-end">
        <app-data-form
          class="block min-w-0"
          [dataFields]="upperFormFields"
          [dataName]="'upperFormFields'"
          [columns]="0"
          (updateFields_child)="handleUpdate($event)"
        ></app-data-form>
        <button
          class="shorter-btn misc-btn md:shrink-0"
          [disabled]="!canSearch"
          (click)="search()"
        >
          <fa-icon [icon]="faSearch" class="mr-1"></fa-icon>Search
        </button>
      </div>
      <div class="w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[52rem]"
          [tableHeaders]="tableHeaders"
          [tableEntries]="tableEntries"
          (open)="openEntry($event)"
        ></app-data-table>
      </div>
    </section>
  </section>
